import { clsx } from "clsx";

export type SpinnerProps = {
  size: "regular" | "large";
  color: "primary" | "secondary" | "inverted" | "destructive";
};

export const Spinner = ({ size, color }: SpinnerProps) => {
  const sizes = {
    regular: "w-[1.6rem] h-[1.6rem] min-w-[1.6rem] min-h-[1.6rem]",
    large: "w-[8rem] h-[8rem] min-w-[8rem] min-h-[8rem]",
  };
  const borderSizes = {
    regular: "border-[0.2rem]",
    large: "border-[0.5rem]",
  };
  const colors = {
    primary: "border-blue-560/40 border-t-blue-560",
    secondary: "border-neutral-850/40 border-t-neutral-850",
    inverted: "border-white/40 border-t-white",
    destructive: "border-red-550/40 border-t-red-550",
  };

  return (
    <div
      className={clsx(
        sizes[size],
        borderSizes[size],
        colors[color],
        "border-solid",
        "rounded-full",
        "animate-spin",
      )}
    />
  );
};
